import React, { useState, useRef, useEffect } from "react";
import { FOREGROUNDCOLOR } from "../../helpers/colors";
import axios from "axios";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Register from "./Register";
import { CheckConfirm, SendConfirm } from "../../services/AccountService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Steps } from "primereact/steps";
import { Toast } from "primereact/toast";
const ForgetPassword = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const toast = useRef(null);
  const items = [
    {
      label: "اعتبارسنجی",
      command: (event: any) => {
        (toast as any).current.show({
          severity: "info",
          summary: "First Step",
          detail: event.item.label,
        });
      },
    },
    {
      label: "تغییر کلمه عبور",
      command: (event: any) => {
        (toast as any).current.show({
          severity: "info",
          summary: "Second Step",
          detail: event.item.label,
        });
      },
    },
  ];

  return (
    <>
      <div className="container mt-5 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6">
        <Toast ref={toast}></Toast>
        <Steps
          model={items}
          activeIndex={activeIndex}
          onSelect={(e) => setActiveIndex(e.index)}
          readOnly={false}
        />
        <div className="col-12">
          <Outlet context={setActiveIndex} />
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
